import { Injectable } from '@angular/core';
import { KeyObjModel } from '@app/models/keyObj.model';
import 'rxjs/add/observable/fromPromise';
import { Credentials } from '@app/core/authentication/authentication.service';
import { SocketService } from '@app/core/socket.service';
import { EtherInterfaceService } from '@app/core/ether-interface.service';

@Injectable()
export class UserProfileService {
  public address: string;
  public depositAddress: string;
  public privateKey: string;
  public accountType: string;
  public keyObj: KeyObjModel;
  public dateCreated: Date;
  public balance = 0;
  public interface = false;
  public auth: Credentials;
  public verified: boolean;
  public network: number;


  public additionalDocs?: Array<string>;
  public createdAt?: Date;
  public depositWallet?: string;
  public docFile?: string;
  public docType?: string;
  public enableLogGameData?: boolean;
  public firstname: string;
  public lastname: string;
  public id?: string;
  public nr?: number;
  public securityKeyObj: KeyObjModel;
  public stats?: {[game: string]: any};
  public testStats?: {[game: string]: any};
  public totp?: any;
  public updatedAt?: Date;
  public userAddress?: string;
  public userCountry?: string;
  public userPostCode?: string;
  public username?: string;
  public utilityFile?: string;
  public userPhone?: string;
  public docFileBack?: string;
  // verified?: {[key: string]: any};

  private _data: {[key: string]: any} = {};

  constructor(private socket: SocketService) {
    //
  }

  fetchUser(credentials: Credentials) {
    this.socket.emit('user', 'getProfile', {
      auth: credentials,
      sort: {},
      limit: 1
    }).toPromise().then((e: any) => {
      const user = e[0];
      this.verified = user.verified.state.toString();
      this.id = user.id;
      this.userCountry = user.userCountry;
      this.userAddress = user.userAddress;
      this.userPostCode = user.userPostCode;
      this.userPhone = user.userPhone;
      this.firstname = user.firstname;
      this.lastname = user.lastname;
      this.docType = user.docType;
      this.docFile = user.docFile;
      this.docFileBack = user.docFileBack;
      this.utilityFile = user.utilityFile;
      this.additionalDocs = user.additionalDocs;
      this.enableLogGameData = user.enableLogGameData;
      this.depositAddress = EtherInterfaceService.prefix(user.depositWallet);
      if (user.username) {
        this.username = user.username;
      }
    }).catch((e: any) => {});
  }

  /**
   * @param {string} key
   * @param value
   */
  set(key: string, value?: any): void {
    if (value) {
      this._data[key] = value;
    } else {
      delete this._data[key];
    }
  }

  /**
   * @param {string} key
   * @param defaultValue
   * @returns {any}
   */
  get(key: string, defaultValue?: any): any {
    if (this._data.hasOwnProperty(key)) {
      return this._data[key];
    }
    return defaultValue !== undefined ? defaultValue : null;
  }

  clear(): void {
    this._data = {};
  }

  reset(): void {
    this.address = null;
    this.depositAddress = null;
    this.privateKey = null;
    this.accountType = null;
    this.keyObj = null;
    this.dateCreated = null;
    this.balance = 0;
    this.interface = null;
    this.auth = null;
    this.verified = null;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/Prod_web-client/src/app/core/user-profile.service.ts